import {ManualTasksService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _ManualTasksService = new ManualTasksService({client});
export {_ManualTasksService as ManualTasksService};
